export const colors = {
  white: '#fff',
  grey: '#e6e6e6',
  darkGrey: '#565656',
  lightGrey: '#f7f7f7',
  principalOrange: '#f5874f',
  reddishOrange: '#ff9271',
  green: '#43aa8b'
};



// WEBPACK FOOTER //
// ./src/constants/styleConstants.js